import React from 'react';

/**
 * Money bag icon drawn in the lucide-react style (24x24, currentColor stroke)
 * so it sits cleanly next to the other sidebar icons.
 */
const MoneyBagIcon = ({ size = 20, className = '', strokeWidth = 1.8, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M8.9 2.5h6.2l-1.5 3.3h-3.2L8.9 2.5Z" />
    <path d="M10.4 5.8C6.7 7.5 3.9 10.7 3.9 14.3a8.1 8.1 0 0 0 16.2 0c0-3.6-2.8-6.8-6.5-8.5Z" />
    <path d="M12 9.9v8.6" />
    <path d="M14.1 11.9h-3a1.5 1.5 0 0 0 0 3h1.8a1.5 1.5 0 0 1 0 3h-3" />
  </svg>
);

export default MoneyBagIcon;
